import styled from '@emotion/styled'
import { css } from '@emotion/react'

export const LabelStyles = ({ theme }) => {
  const PackageCard = theme?.components?.PackageCard
  const labelRadius = PackageCard?.radius || PackageCard?.label?.radius || '0px'

  return css`
    font-size: 12px;
    padding: 4px 24px;
    font-weight: bold;
    line-height: 18px;
    width: fit-content;
    letter-spacing: 1px;
    text-transform: capitalize;
    background-color: ${PackageCard?.label?.backgroundColor ||
    theme.colors.primary.dark.hex};
    color: ${PackageCard?.label?.color || theme.colors.primary.dark.readable};
    border-radius: ${labelRadius};
  `
}

export const Label = styled.div(LabelStyles)
